<template>
  <!-- Header -->
  <header id="header" class="alt">
    <h1 id="logo">
      <a v-on:click="home">URL shortener
        <span>made by d2si</span>
      </a>
    </h1>
    <nav id="nav">
      <ul>
        <li v-if="user">{{ user.email }}</li>
        <li class="current">
          <a class="button" v-on:click="home">Home</a>
        </li>
        <li v-if="user">
          <a class="button" v-on:click="create">New</a>
        </li>
        <li v-if="user">
          <a class="button" v-on:click="urls">My URLs</a>
        </li>
        <li>
          <a class="button primary" v-on:click="signout" v-if="user">Sign Out</a>
          <a class="button primary" v-on:click="signin" v-else>Sign In</a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { Auth } from 'aws-amplify'
import { EventBus } from '../event-bus/event-bus'
import AmplifyStore from '../store/store'

export default {
  name: 'Header',
  computed: {
    user () {
      return AmplifyStore.state.user
    }
  },
  methods: {
    home: function () {
      // Redirect to home page
      this.$router.push('/')
    },
    create: function () {
      // Redirect to create page
      this.$router.push('/create')
    },
    urls: function () {
      // Redirect to url page
      this.$router.push('/urls')
    },
    signin: function () {
      // Redirect to Google Auth view component
      this.$router.push('/auth')
    },
    signout: function () {
      // Logout and emit event
      Auth.signOut().then(
        EventBus.$emit('authState', {
          value: 'signedOut',
          redirectPath: '/'
        })
      ).catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue